// WhatsAppFloat.jsx — No external CSS file needed, styles inline via <style> tag
// If you want to keep using WhatsAppFloat.css, copy the <style> block contents there.

export default function WhatsAppFloat() {
  return (
    <>
      <style>{`
.whatsapp-fab {
  position: fixed;
  bottom: 80px;
  right: 40px;
  z-index: 9999;
  width: 40px;
  height: 40px;
  background: #25D366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(37, 211, 102, 0.45);
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.whatsapp-fab:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 24px rgba(37, 211, 102, 0.6);
}

.whatsapp-fab svg {
  width: 22px;
  height: 22px;
  fill: #ffffff;
  position: relative;
  z-index: 2;
}

/* Ripple Animation */

.wa-ripple {
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(37, 211, 102, 0.4);
  animation: wa-pulse 2s ease-out infinite;
  z-index: 1;
}

@keyframes wa-pulse {
  0%   { transform: scale(1); opacity: 0.7; }
  100% { transform: scale(2); opacity: 0; }
}

/* ===== Tablet ===== */

@media (max-width: 900px) {

.whatsapp-fab{
  right: 25px;
  bottom: 70px;
  width: 45px;
  height: 45px;
}

.wa-ripple{
  width:45px;
  height:45px;
}

}

/* ===== Mobile ===== */

@media (max-width: 600px) {
.whatsapp-fab{
display:none;}


`}</style>

      <a
        href="https://wa.me/919320905751"
        className="whatsapp-fab"
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <div className="wa-ripple" />
        <div className="wa-ripple" style={{ animationDelay: '1s' }} />

        {/* Official WhatsApp SVG icon */}
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.004 2.667C8.64 2.667 2.667 8.639 2.667 16a13.283 13.283 0 0 0 1.888 6.854L2.667 29.333l6.694-1.854A13.284 13.284 0 0 0 16.004 29.333C23.365 29.333 29.333 23.361 29.333 16S23.365 2.667 16.004 2.667zm0 24.267a11.013 11.013 0 0 1-5.619-1.536l-.403-.24-4.18 1.157 1.126-4.098-.263-.421A10.987 10.987 0 0 1 5 16C5 9.925 9.929 5 16.004 5 22.075 5 27 9.925 27 16c0 6.071-4.925 10.934-10.996 10.934zm6.012-8.196c-.328-.165-1.946-.96-2.248-1.069-.302-.11-.521-.165-.74.165-.22.328-.849 1.069-1.04 1.289-.192.22-.384.247-.713.082-.329-.165-1.388-.511-2.644-1.63-.977-.871-1.636-1.947-1.828-2.275-.192-.329-.021-.506.144-.67.148-.147.33-.384.494-.576.165-.192.22-.329.33-.548.11-.22.055-.411-.027-.576-.082-.165-.74-1.783-1.013-2.44-.267-.641-.538-.554-.74-.564l-.631-.011c-.22 0-.576.082-.877.411s-1.152 1.124-1.152 2.743c0 1.619 1.179 3.183 1.343 3.403.165.22 2.318 3.538 5.617 4.961.785.339 1.397.541 1.875.693.787.25 1.504.215 2.07.13.631-.093 1.946-.795 2.22-1.562.274-.768.274-1.426.192-1.562-.082-.137-.302-.22-.631-.384z" />
        </svg>
      </a>
    </>
  );
}
